export default {
  /**
   * Sets a fixed length for a number by padding with zeros or truncating.
   *
   * @param {number} inputNumber - The input number to set the fixed length for.
   * @param {number} length - The desired length of the resulting number.
   * @returns {string} The number with the fixed length as a string.
   */
  EstablecerLogitudFija(inputNumber, length) {
    try {
      const numberOutput = Math.abs(inputNumber);
      const inputNumberString = inputNumber.toString();
      const currentLength = inputNumberString.length;
      const zero = '0'; /* String de cero */

      if (length <= currentLength) {
        if (inputNumber < 0) {
          return `-${numberOutput.toString()}`;
        }
        return numberOutput.toString();
      }

      if (inputNumber < 0) {
        return `-${zero.repeat(length - currentLength)}${numberOutput.toString()}`;
      }
      return ((zero.repeat(length - currentLength)) + numberOutput.toString());
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`ERROR->SoporteNumeracion->EstablecerLogitudFija->${e}`);
      return inputNumber;
    }
  },

  /**
   * Formats a number to the specified number of decimal places.
   *
   * @param {number} value - The number to format.
   * @param {number} precision - The number of decimal places to round to.
   * @returns {number} The formatted number.
   *
   * @example
   * // Returns 1 for 1.00 with 2 decimal places
   * FormatearXDecimales(1.00, 2);
   * // Returns 1.1 for 1.10 with 1 decimal place
   * FormatearXDecimales(1.10, 1);
   * // Returns 1.12 for 1.12 with 2 decimal places
   * FormatearXDecimales(1.12, 2);
   */
  FormatearXDecimales(value, precision) {
    const formattedNumber = value.toFixed(precision);
    return Number.parseFloat(formattedNumber);
  },

  /**
   * Parses a number (decimal or integer) from a string.
   *
   * @param {string} string - The string containing the number to parse.
   * @returns {number|null} The parsed number, or null if parsing fails.
   *
   * @example
   * // Returns 4.5 for "4,5"
   * ParsearNumeroDesdeCadena("4,5");
   * // Returns 4 for "4"
   * ParsearNumeroDesdeCadena("4");
   * // Returns 4.5 for "4.5"
   * ParsearNumeroDesdeCadena("4.5");
   */
  ParsearNumeroDesdeCadena(string) {
    const sanitizedString = string.replace(',', '.');
    return Number.parseFloat(sanitizedString);
  },
};
